import VimeoPlayer from "@vimeo/player";
import { debounce } from "../utils/Performance";

class FeaturedVideo {

    constructor(element) {
        this.iframe = element;

        if (this.iframe.src.includes("vimeo")) {
            this.player = new VimeoPlayer(element);
            this.player_type = "vimeo";
        }

        if (this.iframe.src.includes("youtube")) {
            this.player = this.iframe.contentWindow;
            this.player_type = "youtube";
        }

        if (!this.player) return;

        this.init();

        this.checkScreenSize();

        window.addEventListener(
            "resize",
            debounce(() => {
                 this.checkScreenSize();
            }, 250),
        );

    }

    init() {
        const btns = document.querySelectorAll("[data-pause-featured-video]");

        btns.forEach((btn) => {

            btn.addEventListener("click", this.playPause.bind(this));

        });

    }

    checkScreenSize() {

        if (window.innerWidth < 830) {

            const buttons = document.querySelectorAll("[data-pause-featured-video]");

            buttons.forEach(button => {
                button.classList.remove("playing");  // Remove the playing class
                this.toggleVideoIcons(button, false); // Show play button
            });

            if (this.player_type == "vimeo") {
                this.player.pause();
            }

            if (this.player_type == "youtube") {

                setTimeout(() => {
                    this.player.postMessage(
                        '{"event":"command","func":"pauseVideo","args":""}',
                        "*",
                    );
                }, 300); // delay needed

            }

        }

    }

    toggleVideoIcons(container, isPlaying) {
        container.querySelector('.pause-video').style.display = isPlaying ? 'block' : 'none';
        container.querySelector('.play-video').style.display = isPlaying ? 'none' : 'block';
    }

    playPause(e) {

        const isPlaying = e.currentTarget.classList.contains("playing");
        const mobilePosterImage = document.querySelector(".page-header__featured-video-poster");

        if (e.currentTarget.classList.contains("playing")) {

           

            if (this.player_type == "vimeo") {
                this.player.pause();
            }

            if (this.player_type == "youtube") {
                this.player.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*",
                );
            }

            mobilePosterImage.classList.add("not-playing");
            e.currentTarget.classList.remove("playing");

        } else {

            if (this.player_type == "vimeo") {
                this.player.play();
            }

            if (this.player_type == "youtube") {
                this.player.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*",
                );
            }

             mobilePosterImage.classList.remove("not-playing");
            e.currentTarget.classList.add("playing");
        }

        this.toggleVideoIcons(e.currentTarget, !isPlaying);

    }

}

document.addEventListener("DOMContentLoaded", () => {
    const videos = document.querySelectorAll(".page-header__featured-video iframe");

    videos.forEach((element) => {

        new FeaturedVideo(element);
        
    });

});